import React from 'react';

/// FormElements
import TswForm, { useDetailForm, useRequiredFields } from 'components/v2/FormElements';
import SavePrompt from 'components/v2/FormElements/SavePrompt';
import DialogButtons from 'components/v2/FormElements/Dialog/Buttons';
import TextField from 'components/v2/FormElements/TextField';
import AddDocument from 'components/v2/FormElements/AddDocument';
import Section from 'components/v2/FormElements/Section';
import AttachmentItem from 'components/v2/PageElements/Attachments/Item';

// Components
import ListItem from 'components/v2/FormElements/ListItem';
import SortableComponent from 'components/v2/FormElements/SortableList/SortableComponent';

// MUI
import List from '@mui/material/List';

// Adapter
import { adaptToForm } from 'adapters/v1/digitalFormTemplates/formData';

// Icons
import InfoIcon from '@mui/icons-material/Info';
import SettingsIcon from '@mui/icons-material/Settings';

const Form = ({
  callback,
  loading = false,
  disabled = false,
  resource = {},
  debug = false,
  isDialog = false,
  afterCancel,
  showUpload = true,
}) => {
  const validate = useRequiredFields(['title', 'signer_roles']);
  const signer_roles = [{ label: 'Name', title: 0 }];

  const {
    handleSubmit,
    handleCancel,
    getTextFieldHandlerProps,
    getRequiredTextProps,
    formData,
    formEditMode,
    setFormData,
  } = useDetailForm({
    validate,
    resource: adaptToForm(resource),
    afterCancel,
    callback,
    defaults: { signer_roles, files: {} },
  });

  const hasUpload = !!formData?.files?.filename;

  const onUpload = (props) => {
    setFormData({
      ...formData,
      files: { ...props },
    });
  };

  const onUploadDelete = () => {
    setFormData({
      ...formData,
      files: {},
    });
  };

  const addDocumentProps = {
    description: 'Upload Document',
    onUpload,
  };

  const handleSorted = (values) => {
    setFormData((prev) => ({
      ...prev,
      signer_roles: values,
    }));
  };

  return (
    <TswForm>
      {debug && JSON.stringify(formData)}
      <List>
        <Section title="Details" Icon={InfoIcon}>
          <ListItem>
            <TextField
              {...getTextFieldHandlerProps('title')}
              {...getRequiredTextProps('title')}
              label="Title"
              disabled={disabled}
            />
          </ListItem>

          {showUpload && (
            <ListItem>
              {!hasUpload && <AddDocument {...addDocumentProps} />}
              {hasUpload && (
                <AttachmentItem
                  attachment={{
                    ...formData.files,
                    name: formData.files.filename,
                    text: formData.files.filename,
                  }}
                  destroy={onUploadDelete}
                  permissions={{ destroy: true, skipId: true }}
                />
              )}
            </ListItem>
          )}
        </Section>

        <Section title="Signature Configuration" Icon={SettingsIcon}>
          <ListItem>
            <SortableComponent
              addLabel="Add Roles for Additional Signers"
              allowEmpty={false}
              disabled={disabled}
              itemLabel="Signing Role"
              onChange={handleSorted}
              textFieldProps={{
                ...getRequiredTextProps('signer_roles'),
              }}
              value={formData.signer_roles ?? []}
            />
          </ListItem>
        </Section>
      </List>

      {!isDialog && !disabled && formEditMode && (
        <SavePrompt onCancel={handleCancel} loading={loading} onClick={handleSubmit} />
      )}

      {isDialog && (
        <DialogButtons
          onCancel={handleCancel}
          loading={loading}
          onClick={handleSubmit}
          disabled={disabled}
        />
      )}
    </TswForm>
  );
};

export default Form;
